// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/publish/styles.scss
// module id = 988
// module chunks = 0